import React, { Suspense } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { getToken } from '@/utils/token-util'

const ComponentRender = (props) => {
  
  const { item } = props
  document.title = item.meta?.title || ''
  return item.meta?.requireAuth ? <RequireAuth item={item} {...props} /> : <item.component {...props} routes={item.children} />
}

/* ---- 判断是否需要登录 ----*/
const RequireAuth = (props) => {
  const { item } = props
  const token = getToken()
  if (token === null || token === '') {
    return <Redirect to='/logIn' from={item.path} />
  } else {
    return <item.component {...props} routes={item.children} />
  }
}

const RouterView = (props) => {

  return (
    <Suspense fallback={<h1>loading...</h1>}>
      <Switch>
        {props.routes.map((item, index) => {
          return (
            <Route
              key={index}
              path={item.path}
              exact={item.exact}
              render={(props) =>
                item.redirect ? (
                  <Redirect push to={item.redirect} from={item.path} />
                ) : (
                  <ComponentRender item={item} routes={item.children} {...props} />
                )
              }
            />
          );
        })}
      </Switch>
    </Suspense>
  );
}
export default RouterView;